import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import ArticleDatatable from '../../modules/article/ArticleDatatable';
import ArticleModal from './ArticleModal';



const ArticleTab = (props) => {

    
    const [show , setShow]= useState( false );
    const [recordId, setRecordId ] = useState();    
  

    const handleCallback = (id) => {
          setRecordId(id);       
          setShow(true);   
    };
 
    const modalCallback = (show,id) => {             
      setRecordId(id);  
      setShow(show);           
    }

  
    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
        
          <ArticleDatatable            
            parentCallback={handleCallback}    
            modalShow={show}                                
          />
         
          <ArticleModal 
            modal={show}
            parentCallback={modalCallback}
            selectedRecord={recordId}                      
          />
         
          <Button
            bsStyle="primary"
          //  bsSize="large"
            className="ml-3 mt-3"
            onClick={() => handleCallback('')} 
          >
            <i className="fas fa-plus"></i>
          </Button>
        </div>
    );
};

export default ArticleTab;